import { z } from 'zod'
import { messages } from '../../messages'

export const getBrandSchema = (formatMessage: (descriptor: any) => string) =>
  z.object({
    id: z.number().optional(),
    tenantId: z.number().optional(),
    customerId: z.number().optional(),
    name: z
      .string()
      .min(1, formatMessage(messages.brandNameRequired))
      .max(250, formatMessage(messages.brandNameTooLong))
      .trim()
      .refine((val) => val.length > 0, formatMessage(messages.brandNameRequired)),
    systemDefined: z.boolean().optional(),
    inUse: z.boolean().optional(),
  })

export const brandSchema = z.object({
  id: z.number().optional(),
  tenantId: z.number().optional(),
  name: z
    .string()
    .min(1, messages.brandNameRequired.defaultMessage)
    .max(250, messages.brandNameTooLong.defaultMessage),
  systemDefined: z.boolean().optional(),
  inUse: z.boolean().optional(),
})

export type BrandFormData = z.infer<typeof brandSchema>
